if (!customElements.get('hh-purchase-options')) {
  customElements.define('hh-purchase-options', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', (event) => {
        const radio = event.target.closest('.hh-purchase-radio');
        const select = event.target.closest('.selling_plan_selector');
        if (radio?.checked) {
          const planId = radio.classList.contains('onetime_purchase_button')
            ? ''
            : radio.closest('.hh-purchase-choice').querySelector('.selling_plan_selector')?.value;
          if (planId !== undefined) this.changeSellingPlan(planId, radio.id);
        } else if (select) {
          this.changeSellingPlan(select.value, select.id);
        }
      });
    }

    async changeSellingPlan(planId, focusId) {
      if (this.busy) return;
      const section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
      const fieldset = this.querySelector('fieldset');
      const error = this.querySelector('.hh-purchase-error');
      if (!section || !fieldset) return;
      const cartControls = Array.from(section.querySelectorAll('clever-cart-add, button[type="submit"]'));
      const cartStates = cartControls.map((control) => [control, control.getAttribute('disabled')]);
      const committedPlan = this.querySelector('[name="selling_plan"]').value;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      fieldset.disabled = true;
      if (error) error.hidden = true;
      cartControls.forEach((control) => control.setAttribute('disabled', ''));

      const pageUrl = new URL(window.location.href);
      if (planId) pageUrl.searchParams.set('selling_plan', planId);
      else pageUrl.searchParams.delete('selling_plan');
      pageUrl.searchParams.set('variant', this.dataset.variantId);
      const requestUrl = new URL(pageUrl);
      requestUrl.searchParams.set('section_id', this.dataset.sectionId);

      try {
        const response = await fetch(requestUrl.href, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          method: 'GET'
        });
        if (!response.ok) throw new Error(`Section request failed: ${response.status}`);
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = parsed.getElementById(section.id);
        const nextOptions = nextSection?.querySelector('hh-purchase-options');
        if (!nextOptions || !section.isConnected || !this.isConnected) {
          throw new Error('Purchase-option section is unavailable');
        }
        const nextPlan = nextOptions.querySelector('[name="selling_plan"]')?.value || '';
        if (nextPlan !== String(planId)) throw new Error('Requested selling plan is unavailable');

        const preservedTypes = new Set([
          'payment_buttons', 'reviews', 'bundle_builder', 'cart_add', '@app', 'siblings_and_quantity'
        ]);
        const replacements = [];
        nextSection.querySelectorAll('.product_details .product_details-block').forEach((nextBlock) => {
          if (preservedTypes.has(nextBlock.dataset.type)) return;
          const oldBlock = section.querySelector(`#${CSS.escape(nextBlock.id)}`);
          if (oldBlock) replacements.push([oldBlock, nextBlock]);
        });
        if (!replacements.some(([oldBlock]) => oldBlock.contains(this))) {
          throw new Error('Purchase-option block is unavailable');
        }
        history.replaceState(history.state, '', pageUrl.href);
        replacements.forEach(([oldBlock, nextBlock]) => oldBlock.replaceWith(nextBlock));
        replacements.forEach(([, nextBlock]) => {
          nextBlock.querySelectorAll('script').forEach((oldScript) => {
            const newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach((attribute) => {
              newScript.setAttribute(attribute.name, attribute.value);
            });
            newScript.textContent = oldScript.textContent;
            oldScript.replaceWith(newScript);
          });
        });
        if (focusId) {
          section.querySelector(`#${CSS.escape(focusId)}`)?.focus({ preventScroll: true });
        }
        section.dispatchEvent(new CustomEvent('hh:selling-plan:change', {
          bubbles: true,
          detail: { sellingPlanId: nextPlan, variantId: this.dataset.variantId }
        }));
      } catch (requestError) {
        this.querySelectorAll('.hh-purchase-radio').forEach((radio) => {
          radio.checked = radio.defaultChecked;
        });
        this.querySelectorAll('.selling_plan_selector').forEach((select) => {
          const selected = Array.from(select.options).find((option) => option.defaultSelected);
          if (selected) select.value = selected.value;
        });
        this.querySelector('[name="selling_plan"]').value = committedPlan;
        if (error && this.dataset.errorMessage) {
          error.textContent = this.dataset.errorMessage;
          error.hidden = false;
        }
        console.error(requestError);
      } finally {
        fieldset.disabled = false;
        this.busy = false;
        this.removeAttribute('aria-busy');
        cartStates.forEach(([control, disabled]) => {
          if (disabled === null) control.removeAttribute('disabled');
          else control.setAttribute('disabled', disabled);
        });
      }
    }
  });
}
